<template>
    <div>
        <van-tabs color="#1989fa" v-model="active">

            <van-form @submit="onSubmit">
                <van-field
                        v-model="uservo.username"
                        rows="3"
                        autosize
                        label="客户姓名"
                        type="textarea"
                        placeholder="请输入客户姓名"
                />
                <van-field
                        v-model="uservo.phone"
                        rows="3"
                        autosize
                        label="客户手机号:"
                        type="textarea"
                        placeholder="请输入客户手机号"
                />
                <van-field
                        v-model="uservo.idNo"
                        rows="3"
                        autosize
                        label="证件编号:"
                        type="textarea"
                        placeholder="请输入证件编号"
                />
                <van-field
                        v-model="uservo.companyName"
                        rows="3"
                        autosize
                        label="公司名称:"
                        type="textarea"
                        placeholder="请输入公司名称"
                />
                <div style="margin: 16px">
                    <van-button round block type="info" native-type="submit"
                    >提交
                    </van-button
                    >
                </div>
            </van-form>
        </van-tabs>
    </div>
</template>
<script>
    import URL from "@/api/api";
    import {Toast} from "vant";
    import {UrlSearch, setSession, setLocal} from '@/utils/utils'

    export default {

        data() {
            return {
                fieldValue: '',
                show: false,
                cascaderValue: '',
                isDisabled: false,
                active: "",
                question: "",
                pid: 0,
                cid: '',
                content: '',
                options: [],
                fieldNames: {
                    text: 'name',
                    value: 'code',
                    children: 'child',
                },
                uservo: {
                    id: null,
                    username: "",
                    phone: "",
                    idNo: "",
                    companyName: "",
                    userPhone: "",
                    productCode: ""
                },

                message: "",
                productList: [],
                fileList: [],
                returnFileList: [],
                orderNo: this.$route.query.orderNo,
                status: "0",
                nickName: ""
            };
        },
        mounted() {
            this.getProductTypeAndProduct();
            this.uservo.userId = UrlSearch().biztag
            this.$nextTick(() => {
                if (this.orderNo) {
                    this.orderDetails();
                }
            });
        },
        methods: {
            orderDetails() {
                let data = {
                    orderNo: this.orderNo,
                    openid: localStorage.getItem("openid"),
                };
                this.$fetchGet(URL.orderDetails.url, data).then((res) => {
                    this.pid = res.data.data.pid;
                    this.cid = res.data.data.cid;
                    this.message = res.data.data.tips;
                    this.active = res.data.data.typeId;
                    this.content = res.data.data.content;
                    this.status = res.data.data.status;
                    if (res.data.data.img) {
                        let imgStr = JSON.stringify(res.data.data.img)
                        // let jsonb = imgStr.replace(/\/skjy\//g, this.commonUrl.F_URL + "skjy/")
                        let jsonb = imgStr.replace(/\/skjy\//g, process.env.VUE_APP_BASE_URL + "skjy/")
                        this.fileList = JSON.parse(jsonb)
                    }
                    if (this.status === '0' || this.status === '1') {
                        this.isDisabled = true;
                    }
                });
            },
            getProductTypeAndProduct() {

                this.$fetchGet(URL.getregion.url).then(res => {

                    this.options = res.data
                })
            },

            onFinish({selectedOptions}) {
                console.log(selectedOptions)
                if (selectedOptions.length > 1) {
                    this.uservo.province = selectedOptions[0].code.substr(0, 2)
                    this.uservo.city = selectedOptions[1].code
                } else {
                    this.uservo.province = selectedOptions[0].code.substr(0, 2)
                    this.uservo.city = selectedOptions[0].code
                }

                this.show = false
                this.fieldValue = selectedOptions.map((option) => option.name).join('/');


            },

            beforeDelete(file, fileList) {
                this.fileList.splice(fileList.index, 1)
                let imgId = this.returnFileList.splice(fileList.index, 1)
                this.$fetchGet(URL.removeFile.url, {"fileId": Number(imgId)}).then((res) => {
                    console.log(res.data.msg)
                });
            },

            onSubmit(values) {
                // this.$fetchGet(URL.luupdateuse.url, UrlSearch().biztag).then(res => {
                //
                // })
                this.uservo.userPhone = UrlSearch().agentPhoneNo;
                let userId = localStorage.getItem("UserIdC");
                this.uservo.id = userId;
                let productCode = UrlSearch().productCode;
                this.uservo.productCode = productCode;
                this.$fetchPost(URL.ocft.url, this.uservo).then((res) => {
                    if (res.data.code === 20000) {
                        window.location.href = res.data.data;
                        // this.$fetchPost(URL.ocft.login, {
                        //     userId: userId,
                        //     agentPhoneNo: this.uservo.userPhone,
                        //     productCode: productCode
                        // }).then((res) => {
                        //     if (res.data.code === 20000) {
                        //         window.location.href = res.data.data;
                        //     }
                        // });
                    } else {
                        Toast(res.data.msg);
                    }
                    // let tocken = res.data.data
                    // let redirectUrl = "http://ljt.me235.lutest.luagent.com/loanStepTwo/" + UrlSearch()postcode
                    //     + "?LJTfrom=POSTER&params=" + JSON.stringify({bizKey: UrlSearch().biztag})
                    // redirectUrl = window.encodeURIComponent(redirectUrl)
                    // let url = "http://ljt.me235.lutest.luagent.com/customerJointLogin?token=" + tocken + "&redirectUrl=" + redirectUrl
                    //
                    // console.log("url++++++++" + url);
                    // window.location.href = url;
                    // console.log(res.data)
                    // console.log(res)
                });
            },
        },
    };
</script>
<style scoped>
    .van-tab__pane {
        width: 95%;
        margin: 10px auto;
    }

    .van-card__title {
        max-height: 32px;
        font-weight: 600;
        line-height: 40px;
        font-size: 16px;
    }

    .dropdown-sty {
        width: 100%;
        display: flex;
        background: #fff;
    }

    .pro-tit {
        line-height: 50px;
        padding-left: 10px;
        font-size: 16px;
    }

    .van-dropdown-menu {
        /* width: 70%; */
    }

    .pro-sty >>> .van-dropdown-menu__bar {
        align-items: start;
        background-color: transparent;
        box-shadow: none;
    }

    .van-dropdown-menu__bar {
    }
</style>
